module.exports = __webpack_public_path__ + "img/food.617c8777.svg";